(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["audio-player-links"] && !window.DesignMode) return;
  try {
    
$(function() {
	var audio = $("audio")[0];
	$('#btn-play-pause').on('click', function() {
		//Play/pause the track
		if (audio.paused == false) {
			audio.pause();
			$(this).children('i').removeClass('fa-pause');
			$(this).children('i').addClass('fa-play');
		} else {
			audio.play();
			$(this).children('i').removeClass('fa-play');
			$(this).children('i').addClass('fa-pause');
		}
	});
	$('#btn-stop').on('click', function() {
		//Stop the track
		audio.pause();
		audio.currentTime = 0;
		$('#btn-play-pause').children('i').removeClass('fa-pause');
		$('#btn-play-pause').children('i').addClass('fa-play');
	});
	$('#btn-mute').on('click', function() {
		//Mutes/unmutes the sound
		if(audio.volume != 0) {
			audio.volume = 0;
			$(this).children('i').removeClass('fa-volume-off');
			$(this).children('i').addClass('fa-volume-up');
		} else {
			audio.volume = 1;
			$(this).children('i').removeClass('fa-volume-up');
			$(this).children('i').addClass('fa-volume-off');
		}
	});
	function updateProgress() {
		//Updates the progress bar
		var progress = document.getElementById("progress");
		var value = 0;
		if (audio.currentTime > 0) {
			value = Math.floor((100 / audio.duration) * audio.currentTime);
		}
		progress.style.width = value + "%";
	}
	//Progress Bar event listener
	audio.addEventListener("timeupdate", updateProgress, false);	
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["connect-bar"] && !window.DesignMode) return;
  try {
    
$("#newsletter-toggle").click(function() {
    $("#contact_form").slideToggle( "fast", function() {});
    return false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-music"]) return;
  try {
    
$(window).scroll(function(event) {
  $(".player").each(function(i, el) {
    var el = $(el);
    el.visible = function(partial) {
      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };
    if (el.visible(true)) {
      el.addClass("fadeIn animated"); 
    } else {
      el.removeClass("fadeIn animated");
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-videos"]) return;
  try {
    
$(window).scroll(function(event) {
    $(".video").each(function(i, el) {
        var el = $(el);
        el.visible = function(partial) {
            var $t            = $(this),
                $w            = $(window),
                viewTop       = $w.scrollTop(),
                viewBottom    = viewTop + $w.height(),
                _top          = $t.offset().top,
                _bottom       = _top + $t.height(),
                compareTop    = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;
            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        }; 
        if (el.visible(true)) {
            el.addClass("fadeIn animated");
        } else {
            el.removeClass("fadeIn animated");
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
	new UISearch(document.getElementById('sb-search'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tour"] && !window.DesignMode) return;
  try {
    
var bit = document.createElement('script');
bit.src = 'https://widget.bandsintown.com/main.min.js';
document.head.appendChild(bit);
  $(window).scroll(function(event) {
  $(".bit-event").each(function(i, el) {
    var el = $(el);
    el.visible = function(partial) {
        var $t            = $(this),
            $w            = $(window),
            viewTop       = $w.scrollTop(),
            viewBottom    = viewTop + $w.height(),
            _top          = $t.offset().top,
            _bottom       = _top + $t.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;
        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };
    if (el.visible(true)) {
      el.addClass("fadeIn animated"); 
    } else {
      el.removeClass("fadeIn animated");
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-lightbox"] && !window.DesignMode) return;
  try {
    

function onYouTubeIframeAPIReady() {
  player = new YT.Player('video-placeholder', {
    width: 640,
    height: 360,
    videoId: 'HdzI-191xhU',
    events: {
      onReady: initialize
    }
  });
}
function initialize(){

}            

function deployVideo() {
  jQuery('.mm-product-video-modal-container').addClass('open');
  setTimeout(function() {
    jQuery('.mm-product-video-modal').addClass('open');
    player.playVideo();
  }, 250);
}

function destroyVideo() {
  jQuery('.mm-product-video-modal').removeClass('open');
  setTimeout(function() {
    jQuery('.mm-product-video-modal-container').removeClass('open');
    player.pauseVideo();
  }, 250);
}

jQuery('.mm-video-overlay').on('click', function() {
  destroyVideo();
});

jQuery('.mm-launch').on('click',function() {
  deployVideo();
});


  } catch(e) { console.error(e); }
})();

})();
